module.exports = __webpack_public_path__ + "static/media/onsoc_small.593cec54.jpg";